// In Unicode mode, paired surrogates are one code point and do not match this range.
// Keep this guard dependency-free and compatible with the SDK's ES2022 target.
export const isJsonbRepresentableString = (value: string): boolean => {
  return !value.includes("\u0000") && !/[\uD800-\uDFFF]/u.test(value);
};
